import { formatSeasonStart } from '../../utils/season';
import './YearScopeToggle.css';

/**
 * "This year" (the current season) or "All years" of a reader's history.
 */
const YearScopeToggle = ({ value, onChange, seasonStart }) => (
  <div className="year-scope" role="group" aria-label="Which years to show">
    <button
      type="button"
      className={`year-scope-btn ${value === 'season' ? 'active' : ''}`}
      aria-pressed={value === 'season'}
      onClick={() => onChange('season')}
    >
      This year
    </button>
    <button
      type="button"
      className={`year-scope-btn ${value === 'all' ? 'active' : ''}`}
      aria-pressed={value === 'all'}
      onClick={() => onChange('all')}
    >
      All years
    </button>
    {value === 'season' && seasonStart && (
      <span className="year-scope-note">Since {formatSeasonStart(seasonStart)}</span>
    )}
  </div>
);

export default YearScopeToggle;
